var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem1C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 700 300",
    viewBox: "0 0 700 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.72622,
    x2: 1.5961,
    y1: 0.49096,
    y2: 0.52506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 309.32,
    cy: 525.24,
    r: 17.858,
    gradientTransform: "matrix(.41677 .16196 -.16196 .41677 99.272 -185.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.03018,
    x2: 1.0796,
    y1: 0.49871,
    y2: 0.50321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.72622,
    x2: 1.5961,
    y1: 0.47243,
    y2: 0.51505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 353.83,
    cy: 610.48,
    r: 17.858,
    gradientTransform: "matrix(.43298 .16826 -.16826 .43298 417.22 -239.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.02826,
    x2: 1.0808,
    y1: 0.49708,
    y2: 0.50158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.72622,
    x2: 1.5961,
    y1: 0.46493,
    y2: 0.50755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 402.15,
    cy: 710.37,
    r: 17.858,
    gradientTransform: "matrix(.41375 .16079 -.16079 .41375 213.89 -126.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.0296,
    x2: 1.0821,
    y1: 0.49818,
    y2: 0.50266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("polygon", {
    points: "398.66 83.758 385.39 97.03 385.39 70.013 392.03 58.993 398.66 70.013",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.66 100.35 385.39 113.5 385.39 97.03 398.66 83.758",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.39 113.5 398.66 100.35 398.66 113.74 385.39 113.74",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.39 97.03 385.39 70.013 392.03 58.993 398.66 70.013 398.66 83.758 398.66 100.35 398.66 113.74 385.39 113.74 385.39 113.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.6,
    y: 52.594,
    width: 247.65,
    height: 5.4507,
    fill: "url(#f)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.6,
    y: 52.594,
    width: 247.65,
    height: 5.4507,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.4 83.758 554.13 97.03 554.13 70.013 560.76 58.993 567.4 70.013",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.4 100.35 554.13 113.5 554.13 97.03 567.4 83.758",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "554.13 113.5 567.4 100.35 567.4 113.74 554.13 113.74",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "554.13 97.03 554.13 70.013 560.76 58.993 567.4 70.013 567.4 83.758 567.4 100.35 567.4 113.74 554.13 113.74 554.13 113.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.37 69.184c0.47398 0.23699 1.0664 0.47398 1.5404 0.82946 1.6589 1.3034 2.7254 2.9624 3.1994 5.0953 0.35548 2.1329-0.11849 4.0288-1.3034 5.8062s-2.8439 2.7254-4.9768 3.1994c-1.5404 0.23699-2.9624 0.11849-4.1473-0.35548-0.47398-0.23699-1.0664-0.47398-1.6589-0.94795-1.7774-1.1849-2.9624-2.8439-3.3178-5.0953 0-0.47398 0-0.94795-0.11849-1.3034 0-1.6589 0.47398-3.0808 1.3034-4.5028 1.1849-1.7774 2.9624-2.8439 5.0953-3.1994 1.5404-0.11849 2.9624 0 4.3843 0.47398zm2.1329 6.3987c-0.23699-1.3034-0.94795-2.4884-2.0144-3.4363-0.47398-0.23699-0.82946-0.47398-1.0664-0.59247-0.94795-0.35548-1.8959-0.47398-2.8439-0.23699-1.4219 0.35548-2.6069 1.0664-3.3178 2.1329-0.82946 1.3034-1.1849 2.6069-0.82946 3.9103 0.35548 1.4219 0.94795 2.4884 2.1329 3.3178 0.47398 0.35548 0.94795 0.47398 1.1849 0.59247 0.94795 0.35548 1.8959 0.47398 2.7254 0.35548 1.4219-0.23699 2.6069-0.94795 3.4363-2.1329 0.59247-1.1849 0.82946-2.4884 0.59247-3.9103z",
    fill: "#C1C1C1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.02 74.871c-0.35548 0.82946-0.35548 1.6589-0.23699 2.4884 0.23699 1.1849 0.94795 2.2514 2.0144 2.9624 0.35548 0.23699 0.71097 0.47398 0.94795 0.47398 0.82946 0.35548 1.6589 0.35548 2.4884 0.23699 1.1849-0.23699 2.2514-0.82946 2.9624-1.8959 0.23699-0.47398 0.47398-0.94795 0.47398-1.0664 0.35548-0.82946 0.47398-1.6589 0.23699-2.3699-0.11849-1.3034-0.82946-2.3699-1.8959-3.0808-0.35548-0.23699-0.71097-0.47398-0.94795-0.47398-0.94795-0.35548-1.6589-0.47398-2.4884-0.23699-1.3034 0.23699-2.3699 0.94795-3.0808 1.8959-0.11849 0.35548-0.35548 0.59247-0.47398 1.0664zm-1.1849 2.6069c-0.11849-1.0664-0.11849-2.0144 0.23699-3.0808 0.23699-0.47398 0.47398-0.82946 0.71097-1.1849 0.94795-1.3034 2.1329-2.0144 3.6733-2.3699 1.0664-0.23699 2.2514-0.11849 3.1994 0.23699 0.47398 0.23699 0.82946 0.47398 1.1849 0.71097 1.3034 0.82946 2.1329 2.0144 2.4884 3.6733 0.11849 1.1849 0 2.2514-0.35548 3.1994-0.11849 0.23699-0.35548 0.59247-0.59247 1.1849-0.94795 1.3034-2.2514 2.1329-3.7918 2.3699-1.1849 0.11849-2.1329-0.11849-3.0808-0.47398-0.35548-0.11849-0.71097-0.35548-1.3034-0.59247-1.4219-0.82946-2.1329-2.1329-2.3699-3.6733zm-1.1849-3.5548c-0.35548 0.82946-0.47398 1.7774-0.47398 2.6069-0.11849 0.47398 0 0.82946 0.11849 1.1849 0.35548 1.8959 1.3034 3.4363 2.9624 4.6213 0.47398 0.35548 0.94795 0.71097 1.5404 0.82946 1.1849 0.47398 2.4884 0.59247 3.7918 0.47398 2.0144-0.47398 3.4363-1.4219 4.6213-2.9624 0.47398-0.59247 0.82946-1.1849 0.82946-1.5404 0.47398-1.1849 0.59247-2.6069 0.47398-3.9103-0.35548-2.0144-1.4219-3.4363-2.9624-4.6213-0.47398-0.23699-0.94795-0.59247-1.5404-0.82946-1.3034-0.47398-2.6069-0.59247-3.9103-0.35548-1.8959 0.35548-3.4363 1.3034-4.6213 2.9624-0.11849 0.23699-0.35548 0.82946-0.82946 1.5404zm-1.0664-0.35548c0.47398-0.82946 0.71097-1.4219 0.94795-1.7774 1.3034-1.8959 3.1994-3.0808 5.4507-3.4363 1.5404-0.23699 3.0808-0.11849 4.5028 0.47398 0.94795 0.47398 1.5404 0.82946 1.7774 0.94795 1.8959 1.4219 2.9624 3.1994 3.3178 5.3322 0.35548 1.5404 0.23699 3.0808-0.47398 4.5028-0.23699 0.71097-0.59247 1.3034-0.94795 1.7774-1.3034 1.7774-3.1994 2.9624-5.4507 3.4363-1.5404 0.35548-2.9624 0.23699-4.3843-0.35548-0.59247-0.23699-1.3034-0.59247-1.8959-0.94795-1.7774-1.3034-2.9624-3.0808-3.3178-5.4507l-0.11849-1.5404c0.11849-0.94795 0.23699-1.8959 0.59247-2.9624z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.4 79.137c0.94795 0 1.6589 0.11849 2.3699 0.35548 2.6069 1.1849 3.9103 3.0808 4.0288 5.9247-0.35548 3.9103-2.4884 6.0432-6.2802 6.2802-0.82946 0-1.6589-0.11849-2.3699-0.35548-2.4884-1.0664-3.9103-3.0808-4.0288-6.0432 0.23699-3.7918 2.3699-5.9247 6.2802-6.1617z",
    fill: "url(#e)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.21 85.417c-0.23699-2.6069-1.5404-4.5028-3.7918-5.4507-0.71097-0.23699-1.4219-0.47398-2.0144-0.47398-2.6069 0.11849-4.5028 1.4219-5.4507 3.7918-0.23699 0.59247-0.35548 1.3034-0.35548 2.0144 0.23699 2.6069 1.4219 4.3843 3.7918 5.4507 0.59247 0.23699 1.3034 0.35548 2.0144 0.47398 2.6069-0.23699 4.3843-1.4219 5.4507-3.7918 0.11849-0.59247 0.35548-1.3034 0.35548-2.0144zm-5.9247-6.9912c0.94795 0 1.6589 0.23699 2.4884 0.47398 2.7254 1.1849 4.1473 3.3178 4.5028 6.3987-0.11849 0.94795-0.23699 1.7774-0.47398 2.4884-1.1849 2.7254-3.3178 4.2658-6.3987 4.3843-0.94795 0-1.7774-0.11849-2.4884-0.47398-2.7254-1.0664-4.1473-3.1994-4.3843-6.3987 0-0.94795 0.11849-1.7774 0.47398-2.4884 1.0664-2.6069 3.1994-4.1473 6.2802-4.3843z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.98 84.114 490.14 113.97 448.79 114.09 454.95 84.114",
    fill: "url(#d)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.55 113.5-6.0432-28.913h-27.965l-6.0432 28.794 40.051 0.11849zm-5.3322-29.861 0.11849 0.35548 6.2802 29.861 0.11849 0.59247h-42.776l6.5172-30.809h29.742z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.65 102.01v6.0432h-1.5404v-6.0432h-2.2514v-1.3034h5.9247v1.3034h-2.1329zm4.2658-0.94795c0.47398-0.23699 1.0664-0.47398 1.6589-0.47398s1.1849 0.11849 1.6589 0.47398c0.47398 0.23699 0.82946 0.71097 1.0664 1.1849s0.35548 1.1849 0.35548 1.8959v0.23699c0 0.82946-0.11849 1.3034-0.35548 1.8959-0.23699 0.47398-0.59247 0.94795-1.0664 1.1849s-0.94795 0.47398-1.6589 0.47398c-0.59247 0-1.1849-0.11849-1.6589-0.47398-0.47398-0.23699-0.82946-0.71097-1.0664-1.1849s-0.35548-1.1849-0.35548-1.8959v-0.11849c0-0.82946 0.11849-1.3034 0.35548-1.8959 0.35548-0.59247 0.59247-1.0664 1.0664-1.3034zm0.11849 3.4363c0 0.47398 0.11849 0.94795 0.23699 1.3034s0.23699 0.59247 0.47398 0.82946 0.47398 0.23699 0.82946 0.23699 0.59247-0.11849 0.82946-0.23699c0.23699-0.23699 0.35548-0.47398 0.47398-0.82946s0.23699-0.82946 0.23699-1.3034v-0.23699c0-0.47398-0.11849-0.94795-0.23699-1.3034s-0.35548-0.59247-0.47398-0.82946c-0.23699-0.23699-0.47398-0.23699-0.82946-0.23699s-0.59247 0.11849-0.82946 0.23699c-0.23699 0.23699-0.35548 0.47398-0.47398 0.82946s-0.23699 0.82946-0.23699 1.3034v0.23699zm11.731-3.7918v7.2282h-1.5404l-2.8439-4.6213v4.6213h-1.5404v-7.2282h1.5404l2.8439 4.6213v-4.6213h1.5404z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.05 97.267 469.05 91.105 467.15 91.579 467.15 90.275 470.59 89.091 470.71 89.091 470.71 97.267",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.3 51.409v21.684c-1.3034 0.94795-2.6069 0.94795-4.0288 0v-21.684c1.1849-1.1849 2.4884-1.1849 4.0288 0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.17 24.867 629.02 30.554 624.28 30.554 624.28 28.777 624.28 30.554 619.42 30.554 621.2 27.118",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "621.2 27.118 624.28 21.193 626.17 24.867",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.28 30.554v-1.6589m0 1.6589v21.921",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "627.59 6.5 625.34 10.647 627.71 14.795 625.7 14.795 624.16 11.951 622.62 14.795 620.6 14.795 622.97 10.647 620.6 6.5 622.74 6.5 624.16 9.3439 625.7 6.5",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.4 125.81c4.3843 0 8.0576 1.5404 11.02 4.6213 3.0808 3.0808 4.6213 6.7542 4.6213 11.02s-1.5404 8.0576-4.6213 11.02c-3.0808 3.0808-6.7542 4.6213-11.02 4.6213s-7.9391-1.5404-11.02-4.6213-4.6213-6.7542-4.6213-11.02 1.5404-8.0576 4.6213-11.02c2.9624-3.0808 6.6357-4.6213 11.02-4.6213z",
    fill: "#7493B0",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.65 142.28 0.47398 0.11849-0.59247 2.3699h-6.8727v-0.47398c0.35548-0.23699 0.82946-0.59247 1.3034-0.94795s0.94795-0.71097 1.3034-1.0664c0.47398-0.35548 0.82946-0.82946 1.0664-1.3034s0.47398-0.94795 0.47398-1.4219c0-0.35548-0.11849-0.59247-0.23699-0.82946s-0.23699-0.47398-0.47398-0.59247-0.59247-0.23699-0.94795-0.23699-0.59247 0.11849-0.94795 0.23699c-0.23699 0.11849-0.47398 0.35548-0.71097 0.59247s-0.35548 0.47398-0.47398 0.59247l-0.47398-0.35548 1.0664-1.5404c0.35548-0.35548 0.59247-0.59247 1.0664-0.82946s0.82946-0.23699 1.3034-0.23699c0.59247 0 1.0664 0.11849 1.5404 0.35548s0.82946 0.47398 1.0664 0.94795c0.23699 0.35548 0.35548 0.82946 0.35548 1.3034s-0.11849 1.0664-0.47398 1.5404-0.82946 0.94795-1.5404 1.4219c-0.23699 0.11849-0.47398 0.35548-0.71097 0.47398-0.23699 0.23699-0.59247 0.47398-0.94795 0.71097v0.11849h2.6069c0.35548 0 0.59247 0 0.71097-0.11849 0.23699-0.11849 0.35548-0.11849 0.47398-0.23699 0.23699-0.11849 0.47398-0.35548 0.59247-0.59247z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.024 82.624 47.25 95.284 47.25 69.279 53.637 58.671 60.024 69.279",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.024 98.478 47.25 111.25 47.25 95.284 60.024 82.624",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.25 111.25 60.024 98.478 60.024 111.48 47.25 111.48",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.25 95.284 47.25 69.279 53.637 58.671 60.024 69.279 60.024 82.624 60.024 98.478 60.024 111.48 47.25 111.48 47.25 111.25",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 52.512,
    width: 238.38,
    height: 5.2467,
    fill: "url(#i)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6,
    y: 52.512,
    width: 238.38,
    height: 5.2467,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.53 82.624 195.87 95.284 195.87 69.279 202.14 58.671 208.53 69.279",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.53 98.478 195.87 111.25 195.87 95.284 208.53 82.624",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.87 111.25 208.53 98.478 208.53 111.48 195.87 111.48",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.87 95.284 195.87 69.279 202.14 58.671 208.53 69.279 208.53 82.624 208.53 98.478 208.53 111.48 195.87 111.48 195.87 111.25",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.62 68.48c0.45623 0.22812 1.0265 0.45623 1.4828 0.79841 1.5968 1.2546 2.6233 2.8514 3.0796 4.9045 0.34217 2.053-0.11406 3.878-1.2546 5.5888s-2.7374 2.6233-4.7904 3.0796c-1.4828 0.22812-2.8514 0.11406-3.992-0.34217-0.45623-0.22812-1.0265-0.45623-1.5968-0.91246-1.7109-1.1406-2.8514-2.7374-3.1936-4.9045 0-0.45623 0-0.91246-0.11406-1.2546 0-1.5968 0.45623-2.9655 1.2546-4.3342 1.1406-1.7109 2.8514-2.7374 4.9045-3.0796 1.4828-0.22812 2.8514 0 4.2201 0.45623zm2.053 6.1591c-0.22812-1.2546-0.91246-2.3952-1.939-3.3077-0.45623-0.22812-0.79841-0.45623-1.0265-0.57029-0.91246-0.34217-1.8249-0.45623-2.7374-0.22812-1.3687 0.34217-2.5093 1.0265-3.1936 2.053-0.79841 1.2546-1.1406 2.5093-0.79841 3.7639 0.34217 1.3687 0.91246 2.3952 2.053 3.1936 0.45623 0.34217 0.91246 0.45623 1.1406 0.57029 0.91246 0.34217 1.8249 0.45623 2.6233 0.34217 1.3687-0.22812 2.5093-0.91246 3.3077-2.053 0.57029-1.1406 0.79841-2.3952 0.57029-3.7639z",
    fill: "#C1C1C1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.55 73.955c-0.34217 0.79841-0.34217 1.5968-0.22812 2.3952 0.22812 1.1406 0.91246 2.1671 1.939 2.8514 0.34217 0.22812 0.68435 0.45623 0.91246 0.45623 0.79841 0.34217 1.5968 0.34217 2.3952 0.22812 1.1406-0.22812 2.1671-0.79841 2.8514-1.8249 0.22812-0.45623 0.45623-0.91246 0.45623-1.0265 0.34217-0.79841 0.45623-1.5968 0.22812-2.2812-0.11406-1.2546-0.79841-2.2812-1.8249-2.9655-0.34217-0.22812-0.68435-0.45623-0.91246-0.45623-0.91246-0.34217-1.5968-0.45623-2.3952-0.22812-1.2546 0.22812-2.2812 0.91246-2.9655 1.8249-0.22812 0.34217-0.34217 0.68435-0.45623 1.0265zm-1.2546 2.5093c-0.11406-1.0265-0.11406-1.939 0.22812-2.9655 0.22812-0.45623 0.45623-0.79841 0.68435-1.1406 0.91246-1.2546 2.053-1.939 3.5358-2.2812 1.0265-0.22812 2.1671-0.11406 3.0796 0.22812 0.45623 0.22812 0.79841 0.45623 1.1406 0.68435 1.2546 0.79841 2.053 1.939 2.3952 3.5358 0.11406 1.1406 0 2.1671-0.34217 3.0796-0.11406 0.22812-0.34217 0.57029-0.57029 1.1406-0.91246 1.2546-2.1671 2.053-3.6498 2.2812-1.1406 0.11406-2.053-0.11406-2.9655-0.45623-0.34217-0.11406-0.68435-0.34217-1.2546-0.57029-1.2546-0.79841-2.053-2.053-2.2812-3.5358zm-1.0265-3.4217c-0.34217 0.79841-0.45623 1.7109-0.45623 2.5093-0.11406 0.45623 0 0.79841 0.11406 1.1406 0.34217 1.8249 1.2546 3.3077 2.8514 4.4483 0.45623 0.34217 0.91246 0.68435 1.4828 0.79841 1.1406 0.45623 2.3952 0.57029 3.6498 0.45623 1.939-0.45623 3.3077-1.3687 4.4483-2.8514 0.45623-0.57029 0.79841-1.1406 0.79841-1.4828 0.45623-1.1406 0.57029-2.5093 0.45623-3.7639-0.34217-1.939-1.3687-3.3077-2.8514-4.4483-0.45623-0.22812-0.91246-0.57029-1.4828-0.79841-1.2546-0.45623-2.5093-0.57029-3.7639-0.34217-1.8249 0.34217-3.3077 1.2546-4.4483 2.8514-0.11406 0.22812-0.45623 0.79841-0.79841 1.4828zm-1.0265-0.45623c0.45623-0.79841 0.68435-1.3687 0.91246-1.7109 1.2546-1.8249 3.0796-2.9655 5.2467-3.3077 1.4828-0.22812 2.9655-0.11406 4.3342 0.45623 0.91246 0.45623 1.4828 0.79841 1.7109 0.91246 1.8249 1.3687 2.8514 3.0796 3.1936 5.1326 0.34217 1.4828 0.22812 2.9655-0.45623 4.3342-0.22812 0.68435-0.57029 1.2546-0.91246 1.7109-1.2546 1.7109-3.0796 2.8514-5.2467 3.3077-1.4828 0.34217-2.8514 0.22812-4.2201-0.34217-0.57029-0.22812-1.2546-0.57029-1.8249-0.91246-1.7109-1.2546-2.8514-2.9655-3.1936-5.2467l-0.11406-1.4828c0-0.79841 0.22812-1.8249 0.57029-2.8514z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.77 77.947c0.91246 0 1.5968 0.11406 2.2812 0.34217 2.5093 1.1406 3.7639 2.9655 3.878 5.7029-0.34217 3.7639-2.3952 5.817-6.0451 6.0451-0.79841 0-1.5968-0.11406-2.2812-0.34217-2.3952-1.0265-3.7639-2.9655-3.878-5.817 0.22812-3.5358 2.2812-5.5888 6.0451-5.931z",
    fill: "url(#h)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.47 84.106c-0.22812-2.5093-1.4828-4.3342-3.6498-5.2467-0.68435-0.22812-1.3687-0.45623-1.939-0.45623-2.5093 0.11406-4.3342 1.3687-5.2467 3.6498-0.22812 0.57029-0.34217 1.2546-0.34217 1.939 0.22812 2.5093 1.3687 4.2201 3.6498 5.2467 0.57029 0.22812 1.2546 0.34217 1.939 0.45623 2.5093-0.22812 4.2201-1.3687 5.2467-3.6498 0.22812-0.57029 0.34217-1.2546 0.34217-1.939zm-5.7029-6.6154c0.91246 0 1.5968 0.22812 2.3952 0.45623 2.6233 1.1406 3.992 3.1936 4.3342 6.1591-0.11406 0.91246-0.22812 1.7109-0.45623 2.3952-1.1406 2.6233-3.1936 4.1061-6.1591 4.2201-0.91246 0-1.7109-0.11406-2.3952-0.45623-2.6233-1.0265-3.992-3.0796-4.2201-6.1591 0-0.91246 0.11406-1.7109 0.45623-2.3952 1.0265-2.5093 3.0796-3.992 6.0451-4.2201z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.68 82.852 164.73 111.59 124.81 111.71 130.85 82.852",
    fill: "url(#g)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.16 111.25-5.817-27.83h-26.918l-5.817 27.716 38.552 0.11406zm-5.0186-28.857 0.11406 0.34217 6.0451 28.743 0.11406 0.57029h-41.175l6.2732-29.655h28.629z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.85 100.07v-1.1406h5.7029v1.1406h-2.1671v5.817h-1.4828v-5.817h-2.053zm18.934-1.1406v6.9575h-1.4828l-2.7374-4.4483v4.4483h-1.4828v-6.9575h1.4828l2.7374 4.4483v-4.4483h1.4828zm-8.8965 1.3687c-0.22812-0.22812-0.45623-0.22812-0.79841-0.22812s-0.57029 0.11406-0.79841 0.22812c-0.22812 0.22812-0.34217 0.34217-0.45623 0.79841-0.11406 0.34217-0.22812 0.79841-0.22812 1.2546v0.22812c0 0.45623 0.11406 0.91246 0.22812 1.1406 0.11406 0.34217 0.34217 0.57029 0.45623 0.79841 0.22812 0.22812 0.45623 0.22812 0.79841 0.22812s0.57029-0.11406 0.79841-0.22812c0.22812-0.22812 0.34217-0.34217 0.45623-0.79841 0.11406-0.34217 0.22812-0.79841 0.22812-1.1406v-0.22812c0-0.45623-0.11406-0.91246-0.22812-1.2546 0-0.45623-0.22812-0.68435-0.45623-0.79841zm1.8249 0.11406c0.22812 0.45623 0.34217 1.1406 0.34217 1.8249v0.22812c0 0.79841-0.11406 1.2546-0.34217 1.8249-0.22812 0.45623-0.57029 0.91246-1.0265 1.1406-0.45623 0.34217-1.0265 0.45623-1.5968 0.45623s-1.1406-0.11406-1.5968-0.45623c-0.45623-0.22812-0.79841-0.68435-1.0265-1.1406s-0.34217-1.1406-0.34217-1.8249v-0.22812c0-0.79841 0.11406-1.3687 0.34217-1.8249s0.57029-0.91246 1.0265-1.1406c0.45623-0.34217 1.0265-0.45623 1.5968-0.45623s1.1406 0.11406 1.5968 0.45623c0.45623 0.22812 0.79841 0.57029 1.0265 1.1406z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.43 95.512 144.43 89.581 142.6 90.151 142.6 88.783 145.91 87.528 146.14 87.528 146.14 95.512",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.59 51.486v20.873c-1.2546 0.91246-2.5093 0.91246-3.878 0v-20.873c1.2546-1.1406 2.5093-1.1406 3.878 0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.19 31.64 277.19 30.043 277.19 31.64 272.51 31.64 274.22 28.332 279.02 26.279 281.75 31.64",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.22 28.332 277.19 22.743 279.02 26.279",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.19 31.64v-1.5968m0 1.5968v21.101",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.38 8.6 278.22 12.592 280.5 16.584 278.56 16.584 277.08 13.847 275.59 16.584 273.65 16.584 275.94 12.592 273.65 8.6 275.71 8.6 277.08 11.337 278.56 8.6",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.33 127.72c4.2201 0 7.7559 1.4828 10.607 4.4483 2.9655 2.9655 4.4483 6.5013 4.4483 10.607s-1.4828 7.7559-4.4483 10.607c-2.9655 2.9655-6.5013 4.3342-10.607 4.3342s-7.7559-1.4828-10.607-4.3342c-2.9655-2.9655-4.3342-6.5013-4.3342-10.607 0-4.2201 1.4828-7.7559 4.3342-10.607 2.8514-2.9655 6.3872-4.4483 10.607-4.4483z",
    fill: "#7493B0",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.16 140.72c0-0.34217 0-0.68435-0.11406-0.79841s-0.34217-0.22812-0.57029-0.22812l-1.0265-0.11406v-0.45623c0.57029-0.11406 1.1406-0.22812 1.8249-0.34217 0.57029-0.11406 1.1406-0.34217 1.8249-0.45623v6.0451c0 0.34217 0 0.45623 0.11406 0.68435s0.11406 0.34217 0.22812 0.34217c0.11406 0.11406 0.34217 0.11406 0.57029 0.11406l1.0265 0.11406v0.57029h-5.7029v-0.57029l1.0265-0.11406c0.34217 0 0.57029-0.11406 0.79841-0.34217 0.11406-0.22812 0.22812-0.45623 0.11406-0.91246l-0.11406-3.5358z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.91 230.93 201.22 243.5 201.22 217.68 207.56 207.26 213.91 217.68",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.91 246.67 201.22 259.35 201.22 243.5 213.91 230.93",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.22 259.35 213.91 246.67 213.91 259.57 201.22 259.57",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.22 243.5 201.22 217.68 207.56 207.26 213.91 217.68 213.91 230.93 213.91 246.67 213.91 259.57 201.22 259.57 201.22 259.35",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.6,
    y: 201.15,
    width: 236.65,
    height: 5.2086,
    fill: "url(#c)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.6,
    y: 201.15,
    width: 236.65,
    height: 5.2086,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.36 230.93 379.79 243.5 379.79 217.68 386.13 207.26 392.36 217.68",
    fill: "#BFBFBF",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.36 246.67 379.79 259.35 379.79 243.5 392.36 230.93",
    fill: "#8D8D8D",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.79 259.35 392.36 246.67 392.36 259.57 379.79 259.57",
    fill: "#6A6A6A",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.79 243.5 379.79 217.68 386.13 207.26 392.36 217.68 392.36 230.93 392.36 246.67 392.36 259.57 379.79 259.57 379.79 259.35",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.45 223.11c-0.22646-1.2455-0.90585-2.3779-1.9249-3.2837-0.45292-0.22646-0.79262-0.45292-1.0191-0.56616-0.90585-0.33969-1.8117-0.45292-2.7176-0.22646-1.3588 0.33969-2.4911 1.0191-3.1705 2.0382-0.79262 1.2455-1.1323 2.4911-0.79262 3.7366 0.33969 1.3588 0.90585 2.3779 2.0382 3.1705 0.45292 0.33969 0.90585 0.45292 1.1323 0.56616 0.90585 0.33969 1.8117 0.45292 2.6043 0.33969 1.3588-0.22646 2.4911-0.90585 3.2837-2.0382 0.56616-1.1323 0.90585-2.3779 0.56616-3.7366zm-2.0382-6.1145c0.45292 0.22646 1.0191 0.45292 1.472 0.79262 1.5852 1.2455 2.6043 2.8308 3.0572 4.8689 0.33969 2.0382-0.11323 3.8499-1.2455 5.5483s-2.7176 2.6043-4.7557 3.0572c-1.472 0.22646-2.8308 0.11323-3.9631-0.33969-0.45292-0.22646-1.0191-0.45292-1.5852-0.90585-1.6985-1.1323-2.8308-2.7176-3.1705-4.8689 0-0.45292 0-0.90585-0.11323-1.2455 0-1.5852 0.45292-2.944 1.2455-4.3028 1.1323-1.6985 2.8308-2.7176 4.8689-3.0572 1.472-0.11323 2.8308 0 4.1896 0.45292z",
    fill: "#C1C1C1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.26 225.04c-0.11323-1.0191-0.11323-1.9249 0.22646-2.944 0.22646-0.45292 0.45292-0.79262 0.67939-1.1323 0.90585-1.2455 2.0382-1.9249 3.5102-2.2646 1.0191-0.22646 2.1514-0.11323 3.0572 0.22646 0.45292 0.22646 0.79262 0.45292 1.1323 0.67939 1.2455 0.79262 2.0382 1.9249 2.3779 3.5102 0.11323 1.1323 0 2.1514-0.33969 3.0572-0.11323 0.22646-0.33969 0.56616-0.56616 1.1323-0.90585 1.2455-2.1514 2.0382-3.6234 2.2646-1.1323 0.11323-2.0382-0.11323-2.944-0.45292-0.33969-0.11323-0.67939-0.33969-1.2455-0.56616-1.2455-0.79262-1.9249-2.0382-2.2646-3.5102zm1.2455-2.4911c-0.33969 0.79262-0.33969 1.5852-0.22646 2.3779 0.22646 1.1323 0.90585 2.1514 1.9249 2.8308 0.33969 0.22646 0.67939 0.45292 0.90585 0.45292 0.79262 0.33969 1.5852 0.33969 2.3779 0.22646 1.1323-0.22646 2.1514-0.79262 2.8308-1.8117 0.22646-0.45292 0.45292-0.90585 0.45292-1.0191 0.33969-0.79262 0.45292-1.5852 0.22646-2.2646-0.11323-1.2455-0.79262-2.2646-1.8117-2.944-0.33969-0.22646-0.67939-0.45292-0.90585-0.45292-0.90585-0.33969-1.5852-0.45292-2.3779-0.22646-1.2455 0.22646-2.2646 0.90585-2.944 1.8117-0.11323 0.22646-0.33969 0.56616-0.45292 1.0191zm-2.2646-0.90585c-0.33969 0.79262-0.45292 1.6985-0.45292 2.4911-0.11323 0.45292 0 0.79262 0.11323 1.1323 0.33969 1.8117 1.2455 3.2837 2.8308 4.416 0.45292 0.33969 0.90585 0.67939 1.472 0.79262 1.1323 0.45292 2.3779 0.56616 3.6234 0.45292 1.9249-0.45292 3.2837-1.3588 4.416-2.8308 0.45292-0.56616 0.79262-1.1323 0.79262-1.472 0.45292-1.1323 0.56616-2.4911 0.45292-3.7366-0.33969-1.9249-1.3588-3.2837-2.8308-4.416-0.45292-0.22646-0.90585-0.56616-1.472-0.79262-1.2455-0.45292-2.4911-0.56616-3.7366-0.33969-1.8117 0.33969-3.2837 1.2455-4.416 2.8308-0.11323 0.22646-0.45292 0.67939-0.79262 1.472zm-1.0191-0.45292c0.45292-0.79262 0.67939-1.3588 0.90585-1.6985 1.2455-1.8117 3.0572-2.944 5.2086-3.2837 1.472-0.22646 2.944-0.11323 4.3028 0.45292 0.90585 0.45292 1.472 0.79262 1.6985 0.90585 1.8117 1.3588 2.8308 3.0572 3.1705 5.0954 0.33969 1.472 0.22646 2.944-0.45292 4.3028-0.22646 0.67939-0.56616 1.2455-0.90585 1.6985-1.2455 1.6985-3.0572 2.8308-5.2086 3.2837-1.472 0.33969-2.8308 0.22646-4.1896-0.33969-0.56616-0.22646-1.2455-0.56616-1.8117-0.90585-1.6985-1.2455-2.8308-2.944-3.1705-5.2086l-0.11323-1.472c0.11323-0.90585 0.22646-1.8117 0.56616-2.8308z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.69 226.51c0.90585 0 1.5852 0.11323 2.2646 0.33969 2.4911 1.1323 3.7366 2.944 3.8499 5.6616-0.33969 3.7366-2.3779 5.7748-6.0012 6.0012-0.79262 0-1.5852-0.11323-2.2646-0.33969-2.3779-1.0191-3.7366-2.944-3.8499-5.7748 0.33969-3.5102 2.3779-5.5483 6.0012-5.888z",
    fill: "url(#b)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.58 225.94c0.90585 0 1.5852 0.22646 2.3779 0.45292 2.6043 1.1323 3.9631 3.1705 4.3028 6.1145-0.11323 0.90585-0.22646 1.6985-0.45292 2.3779-1.1323 2.6043-3.1705 4.0763-6.1145 4.1896-0.90585 0-1.6985-0.11323-2.3779-0.45292-2.6043-1.0191-3.9631-3.0572-4.1896-6.1145 0-0.90585 0.11323-1.6985 0.45292-2.3779 1.0191-2.4911 3.0572-3.9631 6.0012-4.1896zm5.6616 6.5674c-0.22646-2.4911-1.472-4.3028-3.6234-5.2086-0.67939-0.22646-1.3588-0.45292-1.9249-0.45292-2.4911 0.11323-4.3028 1.3588-5.2086 3.6234-0.22646 0.56616-0.33969 1.2455-0.33969 1.9249 0.22646 2.4911 1.3588 4.1896 3.6234 5.2086 0.56616 0.22646 1.2455 0.33969 1.9249 0.45292 2.4911-0.22646 4.1896-1.3588 5.2086-3.6234 0.22646-0.56616 0.33969-1.2455 0.33969-1.9249z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.5 231.27 287.39 259.91 247.87 260.03 253.88 231.38",
    fill: "url(#a)",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.83 259.57-5.7748-27.628h-26.723l-5.7748 27.515 38.272 0.11323zm-4.9822-28.761 0.11323 0.33969 6.0012 28.534 0.11323 0.56616h-40.876l6.2277-29.44h28.421z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.35 248.25v5.7748h-1.472v-5.7748h-2.1514v-1.2455h5.6616v1.2455h-2.0382zm4.1896 2.3779c0 0.45292 0.11323 0.90585 0.22646 1.2455s0.22646 0.56616 0.45292 0.79262 0.45292 0.22646 0.79262 0.22646 0.56616-0.11323 0.79262-0.22646c0.22646-0.22646 0.33969-0.45292 0.45292-0.79262s0.22646-0.79262 0.22646-1.2455v-0.22646c0-0.45292-0.11323-0.90585-0.22646-1.2455s-0.33969-0.56616-0.45292-0.79262c-0.22646-0.22646-0.45292-0.22646-0.79262-0.22646s-0.56616 0.11323-0.79262 0.22646c-0.22646 0.22646-0.33969 0.45292-0.45292 0.79262s-0.22646 0.79262-0.22646 1.2455v0.22646zm-1.472-0.22646c0-0.79262 0.11323-1.2455 0.33969-1.8117 0.22646-0.45292 0.56616-0.90585 1.0191-1.1323s1.0191-0.45292 1.5852-0.45292 1.1323 0.11323 1.5852 0.45292c0.45292 0.22646 0.79262 0.67939 1.0191 1.1323s0.33969 1.1323 0.33969 1.8117v0.22646c0 0.79262-0.11323 1.2455-0.33969 1.8117-0.22646 0.45292-0.56616 0.90585-1.0191 1.1323s-0.90585 0.45292-1.5852 0.45292c-0.56616 0-1.1323-0.11323-1.5852-0.45292-0.45292-0.22646-0.79262-0.67939-1.0191-1.1323s-0.33969-1.1323-0.33969-1.8117v-0.22646zm12.569-3.3969v6.9071h-1.472l-2.7176-4.416v4.416h-1.472v-6.9071h1.472l2.7176 4.416v-4.416h1.472z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.82 235.91 269.05 235.91 269.05 243.72 267.35 243.72 267.35 237.83 265.54 238.4 265.54 237.15",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.5 200.01v20.721c-1.2455 0.90585-2.4911 0.90585-3.8499 0v-20.721c1.1323-1.1323 2.3779-1.1323 3.8499 0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.5 179.97 429.5 178.39 429.5 179.97 424.85 179.97 426.55 176.69 431.31 174.65 434.03 179.97",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.55 176.69 429.5 171.14 431.31 174.65",
    fill: "#333",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.5 179.97v-1.472m0 1.472v20.948",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.67 157.1 430.52 161.06 432.78 165.03 430.86 165.03 429.38 162.31 427.91 165.03 425.99 165.03 428.25 161.06 425.99 157.1 428.03 157.1 429.38 159.7 430.86 157.1",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.85 266.01c4.1896 0 7.5865 1.472 10.53 4.3028s4.416 6.4542 4.416 10.53-1.472 7.6997-4.416 10.53c-2.944 2.944-6.4542 4.416-10.53 4.416-4.1896 0-7.6997-1.472-10.53-4.416-2.944-2.944-4.416-6.4542-4.416-10.53s1.472-7.6997 4.416-10.53c2.8308-2.8308 6.341-4.3028 10.53-4.3028z",
    fill: "#7493B0",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.06 278.92c0-0.45292-0.11323-0.90585-0.33969-1.1323s-0.56616-0.33969-1.0191-0.33969c-0.33969 0-0.67939 0.11323-1.0191 0.33969s-0.56616 0.45292-0.79262 0.79262l-0.33969-0.33969 0.79262-1.0191c0.22646-0.22646 0.45292-0.45292 0.90585-0.56616 0.33969-0.22646 0.79262-0.22646 1.1323-0.22646 0.79262 0 1.3588 0.22646 1.8117 0.56616s0.67939 0.90585 0.67939 1.5852c0 0.22646-0.11323 0.45292-0.11323 0.56616-0.11323 0.22646-0.22646 0.33969-0.45292 0.45292-0.11323 0.11323-0.33969 0.22646-0.45292 0.45292-0.22646 0.11323-0.45292 0.33969-0.67939 0.45292v0.11323c0.56616 0.11323 1.0191 0.22646 1.3588 0.45292s0.56616 0.56616 0.79262 0.90585 0.22646 0.79262 0.22646 1.1323c0 0.56616-0.11323 1.0191-0.33969 1.472s-0.56616 0.79262-0.90585 1.1323-0.79262 0.56616-1.1323 0.79262c-0.45292 0.22646-0.79262 0.33969-1.1323 0.45292s-0.56616 0.11323-0.79262 0.11323c-0.33969 0-0.67939-0.11323-1.0191-0.22646s-0.45292-0.22646-0.67939-0.33969c-0.11323-0.11323-0.22646-0.22646-0.22646-0.33969-0.11323-0.11323-0.11323-0.22646 0-0.33969s0.11323-0.22646 0.22646-0.33969l0.22646-0.22646c0.11323-0.11323 0.22646-0.11323 0.22646-0.11323 0.11323 0 0.22646 0.11323 0.22646 0.11323 0.11323 0.11323 0.33969 0.22646 0.45292 0.33969 0.22646 0.11323 0.45292 0.22646 0.56616 0.33969 0.22646 0.11323 0.45292 0.11323 0.79262 0.22646 0.33969 0 0.56616-0.11323 0.79262-0.22646 0.22646-0.22646 0.45292-0.45292 0.56616-0.79262s0.22646-0.79262 0.22646-1.2455-0.11323-0.90585-0.33969-1.2455-0.45292-0.56616-0.79262-0.67939-0.56616-0.22646-0.90585-0.22646c-0.22646 0-0.33969 0-0.56616 0.11323s-0.33969 0.11323-0.45292 0.11323l-0.11323-0.45292c0.79262-0.33969 1.3588-0.56616 1.8117-1.0191 0.56616-0.56616 0.79262-1.0191 0.79262-1.5852z",
    fill: "#fff",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1C);
export default __webpack_public_path__ + "static/media/item1c.6b98b8e07eab03b51ccc3ab34ce8792a.svg";
export { ForwardRef as ReactComponent };